import React, { useState, useEffect, useContext, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

import { LibraryProvider } from "./libraryContext";
import useInfiniteLibrary from "./useInfiniteLibrary";
import { useGetSeachParam } from "../useSearchParams";
import useAccountSettings from "../ManageAccount/useAccountSettings";
import Navigation from "./Navigation";
import CustomDrawer from "../Components/CustomDrawer";
import CustomContent from "../Components/CustomContent";
import LibraryList from "./LibraryList";
import Interaction from "../Interaction";
import AppContext from "../appContext";
import Toolbar from "./Toolbar";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { logging } from "../tools";

const navBarWidth = 270;

export default function Library(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const history = useHistory();
  const mobile = useMediaQuery(theme.breakpoints.down("lg"));
  const listInnerRef = useRef();
  const interactionId = Number(useGetSeachParam("i"));
  const contextId = Number(useGetSeachParam("c"));
  const menuLibrary = props.match.params.type; // access: public, local, contexts, contextId
  const [query, setQuery] = useState({
    q: "", // search text
    t: [], // tags
    a: menuLibrary, // access: public, local, contexts, contextId
    contextId: contextId, // in case a: contextId (get interactions from context)
  });
  const [open, setOpen] = useState(false); // left navigation bar
  const { dispatch } = useContext(AppContext);
  const itemWidth = mobile || interactionId ? "100%" : "70%";

  // server state
  const {
    library,
    isLibraryLoading,
    fetchNextPage,
    refetchLibrary,
    isLibraryError,
  } = useInfiniteLibrary(query);
  const {
    accountSettings: { code: myPractitionerCode },
  } = useAccountSettings();
  const handlePathChange = ({ path, search }) => {
    const pathname = `/library/${path}`;
    history.push({ pathname, search }); // go to the path
    dispatch({ type: "SET_LIBRARY_PATH", payload: `${pathname}${search}` }); // remember path in memory
  };
  const handleQuery = ({ type, payload }) => {
    let val = { ...query }; // set the query
    switch (type) {
      case "search":
        val.q = payload;
        break;
      case "navButtonClick":
        val.a = payload;
        val.q = ""; // clear the search
        handlePathChange({ path: payload, search: "" });
        break;
      case "navContextClick":
        val.a = "contextId";
        val.q = ""; // clear the search
        val.contextId = payload;
        handlePathChange({ path: "contextId", search: `?c=${payload}` });
        break;
      case "refresh":
        break;
      default:
        break;
    }
    setQuery(val);
  };

  useEffect(() => {
    refetchLibrary();
  }, [query]);

  useEffect(() => {
    setOpen(!mobile);
  }, [mobile]);

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight + 10 >= scrollHeight) {
        // correction of 10
        logging("reached bottom");
        fetchNextPage();
      }
    }
  };

  return (
    <div>
      <LibraryProvider value={{ query, handleQuery }}>
        {isLibraryLoading ? (
          <div
            style={{
              position: "fixed",
              width: "100%",
              zIndex: theme.zIndex.appBar,
            }}
          >
            <LinearProgress />
          </div>
        ) : null}
        {open ? (
          <CustomDrawer
            width={navBarWidth}
            open={open}
            content={
              <Navigation
                width={navBarWidth}
                mobile={false}
                setOpen={setOpen}
              />
            }
          />
        ) : (
          false
        )}
        <CustomContent
          open={open}
          marginLeft={navBarWidth}
          content={
            <Box>
              <Box height={"8vh"}>
                <Toolbar
                  open={open}
                  setOpen={setOpen}
                  myPractitionerCode={myPractitionerCode}
                />
              </Box>
              <Box sx={{ display: "flex" }}>
                <Box
                  height={"92vh"}
                  width={interactionId ? "50%" : "100%"}
                  sx={{ overflow: "auto" }}
                  onScroll={onScroll}
                  ref={listInnerRef}
                >
                  {!isLibraryLoading && !isLibraryError ? (
                    <Box width={itemWidth}>
                      <LibraryList
                        myPractitionerCode={myPractitionerCode}
                        library={library}
                      />
                    </Box>
                  ) : null}
                  {isLibraryError ? (
                    <Box p={2}>
                      <Typography>{t("common.noAccess")}</Typography>
                    </Box>
                  ) : null}
                </Box>
                {interactionId ? (
                  <Box height={"92vh"} width={"50%"} sx={{ overflow: "auto" }}>
                    <Interaction />
                  </Box>
                ) : null}
              </Box>
            </Box>
          }
        />
      </LibraryProvider>
    </div>
  );
}

// const questionnaire = [
//   {
//     name: "Test",
//     language: "Dutch",
//     filledInBy: "Client",
//     description: "Description",
//     constructs: "Constructs",
//     descriptionItems: "Description items",
//     tags: ["tag"],
//     nItem: 0,
//     usefulFor: ["single questionnaire"],
//     references: [
//       "@misc{schmiedek2010hundred, title={Hundred Days of Cognitive Training Enhance Broad Cognitive Abilities in Adulthood: Findings from the COGITO Study. Front Aging Neurosci. 2010; 2},   author={Schmiedek, F and Lovden, M and Lindenberger, U},   year={2010},   publisher={Epub 2010/08/21. doi: 10.3389/fnagi. 2010.00027 27 [pii]. PMID: 20725526} }",
//     ],
//   },
// ];
